// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_heading__0CJ\\+E {
  color: var(--text);
  font-size: 0.875rem;
  font-weight: 600;
  margin: 0;
}

.Footer_body__pVer5 {
  color: var(--text-secondary);
  font-size: 0.875rem;
  line-height: 1.25rem;
  max-width: 82rem;
}

.Footer_link__3Ie8d {
  color: var(--text);
  font-size: 0.875rem;
  text-decoration: none;
}

.Footer_link__3Ie8d:hover {
  color: var(--accent-strong);
  text-decoration: underline;
}

.Footer_separator__BhOfx {
  color: var(--text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".heading {\n  color: var(--text);\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.body {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  max-width: 82rem;\n}\n\n.link {\n  color: var(--text);\n  font-size: 0.875rem;\n  text-decoration: none;\n}\n\n.link:hover {\n  color: var(--accent-strong);\n  text-decoration: underline;\n}\n\n.separator {\n  color: var(--text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `Footer_heading__0CJ+E`,
	"body": `Footer_body__pVer5`,
	"link": `Footer_link__3Ie8d`,
	"separator": `Footer_separator__BhOfx`
};
export default ___CSS_LOADER_EXPORT___;
